import { setTerm } from './helpers';

export const setOfferId = setTerm('id');
